// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AlgemeneVoorwaardenRouteImport } from './routes/algemene-voorwaarden'
import { Route as BeheerRouteImport } from './routes/beheer'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as InternationaalVerhuizenRouteImport } from './routes/internationaal-verhuizen'
import { Route as KantoorverhuizingRouteImport } from './routes/kantoorverhuizing'
import { Route as OfferteRouteImport } from './routes/offerte'
import { Route as OverOnsRouteImport } from './routes/over-ons'
import { Route as PianoVerhuizenRouteImport } from './routes/piano-verhuizen'
import { Route as PrivacybeleidRouteImport } from './routes/privacybeleid'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as SpoedverhuizingRouteImport } from './routes/spoedverhuizing'
import { Route as StudentenverhuizingRouteImport } from './routes/studentenverhuizing'
import { Route as VerhuiskostenRouteImport } from './routes/verhuiskosten'
import { Route as VerhuistipsRouteImport } from './routes/verhuistips'
import { Route as VlogRouteImport } from './routes/vlog'
import { Route as WoningontruimingDenHaagRouteImport } from './routes/woningontruiming-den-haag'
import { Route as DienstenIndexRouteImport } from './routes/diensten.index'
import { Route as DienstenSlugRouteImport } from './routes/diensten.$slug'
import { Route as WerkgebiedIndexRouteImport } from './routes/werkgebied.index'
import { Route as WerkgebiedSlugRouteImport } from './routes/werkgebied.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AlgemeneVoorwaardenRoute = AlgemeneVoorwaardenRouteImport.update({
            id: '/algemene-voorwaarden',path: '/algemene-voorwaarden',getParentRoute: () => rootRouteImport
          })
const BeheerRoute = BeheerRouteImport.update({
            id: '/beheer',path: '/beheer',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const InternationaalVerhuizenRoute = InternationaalVerhuizenRouteImport.update({
            id: '/internationaal-verhuizen',path: '/internationaal-verhuizen',getParentRoute: () => rootRouteImport
          })
const KantoorverhuizingRoute = KantoorverhuizingRouteImport.update({
            id: '/kantoorverhuizing',path: '/kantoorverhuizing',getParentRoute: () => rootRouteImport
          })
const OfferteRoute = OfferteRouteImport.update({
            id: '/offerte',path: '/offerte',getParentRoute: () => rootRouteImport
          })
const OverOnsRoute = OverOnsRouteImport.update({
            id: '/over-ons',path: '/over-ons',getParentRoute: () => rootRouteImport
          })
const PianoVerhuizenRoute = PianoVerhuizenRouteImport.update({
            id: '/piano-verhuizen',path: '/piano-verhuizen',getParentRoute: () => rootRouteImport
          })
const PrivacybeleidRoute = PrivacybeleidRouteImport.update({
            id: '/privacybeleid',path: '/privacybeleid',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const SpoedverhuizingRoute = SpoedverhuizingRouteImport.update({
            id: '/spoedverhuizing',path: '/spoedverhuizing',getParentRoute: () => rootRouteImport
          })
const StudentenverhuizingRoute = StudentenverhuizingRouteImport.update({
            id: '/studentenverhuizing',path: '/studentenverhuizing',getParentRoute: () => rootRouteImport
          })
const VerhuiskostenRoute = VerhuiskostenRouteImport.update({
            id: '/verhuiskosten',path: '/verhuiskosten',getParentRoute: () => rootRouteImport
          })
const VerhuistipsRoute = VerhuistipsRouteImport.update({
            id: '/verhuistips',path: '/verhuistips',getParentRoute: () => rootRouteImport
          })
const VlogRoute = VlogRouteImport.update({
            id: '/vlog',path: '/vlog',getParentRoute: () => rootRouteImport
          })
const WoningontruimingDenHaagRoute = WoningontruimingDenHaagRouteImport.update({
            id: '/woningontruiming-den-haag',path: '/woningontruiming-den-haag',getParentRoute: () => rootRouteImport
          })
const DienstenIndexRoute = DienstenIndexRouteImport.update({
            id: '/diensten/',path: '/diensten/',getParentRoute: () => rootRouteImport
          })
const DienstenSlugRoute = DienstenSlugRouteImport.update({
            id: '/diensten/$slug',path: '/diensten/$slug',getParentRoute: () => rootRouteImport
          })
const WerkgebiedIndexRoute = WerkgebiedIndexRouteImport.update({
            id: '/werkgebied/',path: '/werkgebied/',getParentRoute: () => rootRouteImport
          })
const WerkgebiedSlugRoute = WerkgebiedSlugRouteImport.update({
            id: '/werkgebied/$slug',path: '/werkgebied/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AlgemeneVoorwaardenRoute: AlgemeneVoorwaardenRoute,BeheerRoute: BeheerRoute,ContactRoute: ContactRoute,InternationaalVerhuizenRoute: InternationaalVerhuizenRoute,KantoorverhuizingRoute: KantoorverhuizingRoute,OfferteRoute: OfferteRoute,OverOnsRoute: OverOnsRoute,PianoVerhuizenRoute: PianoVerhuizenRoute,PrivacybeleidRoute: PrivacybeleidRoute,ReviewsRoute: ReviewsRoute,SpoedverhuizingRoute: SpoedverhuizingRoute,StudentenverhuizingRoute: StudentenverhuizingRoute,VerhuiskostenRoute: VerhuiskostenRoute,VerhuistipsRoute: VerhuistipsRoute,VlogRoute: VlogRoute,WoningontruimingDenHaagRoute: WoningontruimingDenHaagRoute,DienstenSlugRoute: DienstenSlugRoute,WerkgebiedSlugRoute: WerkgebiedSlugRoute,DienstenIndexRoute: DienstenIndexRoute,WerkgebiedIndexRoute: WerkgebiedIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)